import {match} from 'ts-pattern';

import {BankAccountDomain} from '@dms/api/base';
import i18n from '@dms/i18n';

export const getBankAccountDomainLabel = (domain: BankAccountDomain) =>
  match(domain)
    .with('SALES', () => i18n.t('entity.bank.labels.domainSales'))
    .with('AFTS', () => i18n.t('entity.bank.labels.domainAfterSales'))
    .exhaustive();
